require("core-js/modules/es.array.reduce.js");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var a = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(r, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 8);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function (e) {
    var t = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
    }

    return t;
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function (e) {
    var t = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
    }

    return t;
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function (e, t, n, a, o, l, i) {
    var u = n + (-o * (t - a) + -l * n) * e,
        s = t + u * e;
    if (Math.abs(u) < i && Math.abs(s - a) < i) return r[0] = a, r[1] = 0, r;
    return r[0] = s, r[1] = u, r;
  };
  var r = [0, 0];
  e.exports = t.default;
}, function (e, t, n) {
  (function (t) {
    (function () {
      var n, r, a;
      "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
        return performance.now();
      } : null != t && t.hrtime ? (e.exports = function () {
        return (n() - a) / 1e6;
      }, r = t.hrtime, a = (n = function n() {
        var e;
        return 1e9 * (e = r())[0] + e[1];
      })()) : Date.now ? (e.exports = function () {
        return Date.now() - a;
      }, a = Date.now()) : (e.exports = function () {
        return new Date().getTime() - a;
      }, a = new Date().getTime());
    }).call(this);
  }).call(this, n(10));
}, function (e, t, n) {
  (function (t) {
    for (var r = n(21), a = "undefined" == typeof window ? t : window, o = ["moz", "webkit"], l = "AnimationFrame", i = a["request" + l], u = a["cancel" + l] || a["cancelRequest" + l], s = 0; !i && s < o.length; s++) {
      i = a[o[s] + "Request" + l], u = a[o[s] + "Cancel" + l] || a[o[s] + "CancelRequest" + l];
    }

    if (!i || !u) {
      var c = 0,
          f = 0,
          p = [];
      i = function i(e) {
        if (0 === p.length) {
          var t = r(),
              n = Math.max(0, 1e3 / 60 - (t - c));
          c = n + t, setTimeout(function () {
            var e = p.slice(0);
            p.length = 0;

            for (var t = 0; t < e.length; t++) {
              if (!e[t].cancelled) try {
                e[t].callback(c);
              } catch (e) {
                setTimeout(function () {
                  throw e;
                }, 0);
              }
            }
          }, Math.round(n));
        }

        return p.push({
          handle: ++f,
          callback: e,
          cancelled: !1
        }), f;
      }, u = function u(e) {
        for (var t = 0; t < p.length; t++) {
          p[t].handle === e && (p[t].cancelled = !0);
        }
      };
    }

    e.exports = function (e) {
      return i.call(a, e);
    }, e.exports.cancel = function () {
      u.apply(a, arguments);
    }, e.exports.polyfill = function (e) {
      e || (e = a), e.requestAnimationFrame = i, e.cancelAnimationFrame = u;
    };
  }).call(this, n(20));
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function (e, t, n) {
    for (var r in t) {
      if (Object.prototype.hasOwnProperty.call(t, r)) {
        if (0 !== n[r]) return !1;
        var a = "number" == typeof t[r] ? t[r] : t[r].val;
        if (e[r] !== a) return !1;
      }
    }

    return !0;
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.AttributeMotion = t.TransformMotion = t.SvgLoader = t.SvgProxy = void 0;
  var r = l(n(12)),
      a = l(n(16)),
      o = n(17);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.SvgProxy = a.default, t.SvgLoader = r.default, t.TransformMotion = o.TransformMotion, t.AttributeMotion = o.AttributeMotion;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
      a = n(0);
  var o = ((r = a) && r.__esModule ? r : {
    default: r
  }).default.createContext(null);
  t.default = o;
}, function (e, t) {
  var n,
      r,
      a = e.exports = {};

  function o() {
    throw new Error("setTimeout has not been defined");
  }

  function l() {
    throw new Error("clearTimeout has not been defined");
  }

  function i(e) {
    if (n === setTimeout) return setTimeout(e, 0);
    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

    try {
      return n(e, 0);
    } catch (t) {
      try {
        return n.call(null, e, 0);
      } catch (t) {
        return n.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : o;
    } catch (e) {
      n = o;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : l;
    } catch (e) {
      r = l;
    }
  }();
  var u,
      s = [],
      c = !1,
      f = -1;

  function p() {
    c && u && (c = !1, u.length ? s = u.concat(s) : f = -1, s.length && d());
  }

  function d() {
    if (!c) {
      var e = i(p);
      c = !0;

      for (var t = s.length; t;) {
        for (u = s, s = []; ++f < t;) {
          u && u[f].run();
        }

        f = -1, t = s.length;
      }

      u = null, c = !1, function (e) {
        if (r === clearTimeout) return clearTimeout(e);
        if ((r === l || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

        try {
          r(e);
        } catch (t) {
          try {
            return r.call(null, e);
          } catch (t) {
            return r.call(this, e);
          }
        }
      }(e);
    }
  }

  function y(e, t) {
    this.fun = e, this.array = t;
  }

  function m() {}

  a.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }
    s.push(new y(e, t)), 1 !== s.length || c || i(d);
  }, y.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = m, a.addListener = m, a.once = m, a.off = m, a.removeListener = m, a.removeAllListeners = m, a.emit = m, a.prependListener = m, a.prependOnceListener = m, a.listeners = function (e) {
    return [];
  }, a.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, a.cwd = function () {
    return "/";
  }, a.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, a.umask = function () {
    return 0;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = {
    noWobble: {
      stiffness: 170,
      damping: 26
    },
    gentle: {
      stiffness: 120,
      damping: 14
    },
    wobbly: {
      stiffness: 180,
      damping: 12
    },
    stiff: {
      stiffness: 210,
      damping: 20
    }
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = s(n(0)),
      l = s(n(1)),
      i = s(n(13)),
      u = s(n(9));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      if (n.mounted = !1, n.state = {
        svg: null,
        svgCount: 0
      }, null == o.default.Fragment) throw new Error("This version of React doesn't support Fragments, please update it");
      return n.onSVGReady = n.onSVGReady.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), a(t, [{
      key: "componentDidMount",
      value: function value() {
        this.mounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1;
      }
    }, {
      key: "onSVGReady",
      value: function value(e) {
        var t = this;
        setTimeout(function () {
          t.mounted && (t.setState(r({}, t.state, {
            svg: e,
            svgCount: t.state.svgCount + 1
          })), t.props.onSVGReady(e));
        }, 0);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.path,
            n = (e.onSVGReady, e.children, e.svgXML),
            a = function (e, t) {
          var n = {};

          for (var r in e) {
            t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
          }

          return n;
        }(e, ["path", "onSVGReady", "children", "svgXML"]),
            l = null != this.state.svg ? this.props.children : null;

        return o.default.createElement(o.default.Fragment, null, o.default.createElement(i.default, r({
          path: t,
          callback: this.onSVGReady,
          svgXML: n
        }, a)), o.default.createElement(u.default.Provider, {
          value: {
            path: t,
            svgCount: this.state.svgCount,
            svg: this.state.svg
          }
        }, l));
      }
    }]), t;
  }(o.default.Component);

  t.default = c, c.propTypes = {
    path: l.default.string,
    svgXML: l.default.string,
    onSVGReady: l.default.func,
    style: l.default.object,
    children: l.default.any
  }, c.defaultProps = {
    path: null,
    svgXML: null,
    onSVGReady: function onSVGReady() {},
    style: null
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = i(n(1)),
      l = i(n(0));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function u(e, t) {
    var n = {};

    for (var r in e) {
      t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }

    return n;
  }

  var s = "undefined" != typeof window ? n(14) : void 0,
      c = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.refCallback = e.refCallback.bind(e), e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), a(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.path === e.path && this.props.svgXML === e.svgXML || (this.container && (this.container.innerHTML = ""), this.renderSVG(this.props));
      }
    }, {
      key: "refCallback",
      value: function value(e) {
        e && (this.container = e, this.renderSVG());
      }
    }, {
      key: "renderSVG",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props,
            n = this.container,
            r = t.callback,
            a = (t.path, t.svgXML),
            o = (t.className, u(t, ["callback", "path", "svgXML", "className"]));
        s(n, {
          each: function each(t) {
            if (t) throw new Error(t);
            r(e.container);
          },
          svgXML: a
        }, function () {
          n && o && Object.keys(o).reduce(function (e, t) {
            return "style" !== t && e.setAttribute(t, o[t]), n;
          }, n);
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = (e.callback, e.path, e.svgXML, u(e, ["callback", "path", "svgXML"]));
        return l.default.createElement("svg", r({
          ref: this.refCallback,
          "data-src": this.props.path
        }, t));
      }
    }]), t;
  }(l.default.Component);

  t.default = c, c.defaultProps = {
    callback: function callback() {},
    path: null,
    svgXML: null
  }, c.propTypes = {
    callback: o.default.func,
    path: o.default.string,
    svgXML: o.default.string
  };
}, function (e, t, n) {
  "use strict";

  (function (e) {
    var r,
        a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    /**
     * Changes:
     * - Don't replace the node.  Justs its innerHTML
     * Adapted from:
     * Original Copyright notice ---------------------------
     * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
     * https://github.com/iconic/SVGInjector
     *
     * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
     * @license MIT
     *
     */

    !function (o, l) {
      var i = "file:" === o.location.protocol;
      l.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");

      var u = Array.prototype.forEach || function (e, t) {
        if (null == this || "function" != typeof e) throw new TypeError();
        var n,
            r = this.length >>> 0;

        for (n = 0; n < r; ++n) {
          n in this && e.call(t, this[n], n, this);
        }
      },
          s = {},
          c = 0,
          f = [],
          p = [],
          d = function d(e) {
        return e.cloneNode(!0);
      },
          y = function y(e, t) {
        p[e] = p[e] || [], p[e].push(t);
      },
          m = function m(e, t) {
        if (void 0 !== s[e]) s[e] instanceof SVGSVGElement ? t(d(s[e])) : y(e, t);else {
          if (!o.XMLHttpRequest) return t("Browser does not support XMLHttpRequest"), !1;
          s[e] = {}, y(e, t);
          var n = new XMLHttpRequest();
          n.onreadystatechange = function () {
            if (4 === n.readyState) {
              if (404 === n.status || null === n.responseXML) return t("Unable to load SVG file: " + e), i && t("Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver."), t(), !1;
              if (!(200 === n.status || i && 0 === n.status)) return t("There was a problem injecting the SVG: " + n.status + " " + n.statusText), !1;
              if (n.responseXML instanceof Document) s[e] = n.responseXML.documentElement;else if (DOMParser && DOMParser instanceof Function) {
                var r;

                try {
                  r = new DOMParser().parseFromString(n.responseText, "text/xml");
                } catch (e) {
                  r = void 0;
                }

                if (!r || r.getElementsByTagName("parsererror").length) return t("Unable to parse SVG file: " + e), !1;
                s[e] = r.documentElement;
              }
              !function (e) {
                for (var t = 0, n = p[e].length; t < n; t++) {
                  !function (t) {
                    setTimeout(function () {
                      p[e][t](d(s[e]));
                    }, 0);
                  }(t);
                }
              }(e);
            }
          }, n.open("GET", e), n.overrideMimeType && n.overrideMimeType("text/xml"), n.send();
        }
      },
          h = function h(e, t) {
        if (void 0 === t || "string" == typeof t) return !1;
        var n = e.getAttribute("id");
        n && t.setAttribute("id", n);
        var r = e.getAttribute("title");
        r && t.setAttribute("title", r);
        var a = [].concat(t.getAttribute("class") || [], "injected-svg", e.getAttribute("class") || []).join(" ");
        t.setAttribute("class", function (e) {
          for (var t = {}, n = (e = e.split(" ")).length, r = []; n--;) {
            t.hasOwnProperty(e[n]) || (t[e[n]] = 1, r.unshift(e[n]));
          }

          return r.join(" ");
        }(a));
        var o = e.getAttribute("style");
        o && t.setAttribute("style", o);
        var l = [].filter.call(e.attributes, function (e) {
          return /^data-\w[\w\-]*$/.test(e.name);
        });
        u.call(l, function (e) {
          e.name && e.value && t.setAttribute(e.name, e.value);
        });
        var i,
            s,
            p,
            d,
            y,
            m = {
          clipPath: ["clip-path"],
          "color-profile": ["color-profile"],
          cursor: ["cursor"],
          filter: ["filter"],
          linearGradient: ["fill", "stroke"],
          marker: ["marker", "marker-start", "marker-mid", "marker-end"],
          mask: ["mask"],
          pattern: ["fill", "stroke"],
          radialGradient: ["fill", "stroke"]
        };
        Object.keys(m).forEach(function (e) {
          i = e, p = m[e];

          for (var n = 0, r = (s = t.querySelectorAll("defs " + i + "[id]")).length; n < r; n++) {
            var a;
            d = s[n].id, y = d + "-" + c, u.call(p, function (e) {
              for (var n = 0, r = (a = t.querySelectorAll("[" + e + '*="' + d + '"]')).length; n < r; n++) {
                a[n].setAttribute(e, "url(#" + y + ")");
              }
            }), s[n].id = y;
          }
        }), t.removeAttribute("xmlns:a");
        var h = t.querySelectorAll("style");
        if (u.call(h, function (e) {
          e.textContent += "";
        }), v(e, t), t.hasAttributes()) for (var g = t.attributes, b = g.length - 1; b >= 0; b--) {
          g[b].name + "->" + g[b].value, e.setAttribute(g[b].name, g[b].value);
        }
        delete f[f.indexOf(e)], e = null, c++;
      },
          v = function v(e, t) {
        if (e.innerHTML = t.innerHTML || "", !e.innerHTML) {
          var n = l.createElement("div"),
              r = "<svg>" + function (e) {
            var t = new XMLSerializer();
            return Array.prototype.slice.call(e.childNodes).map(function (e) {
              return t.serializeToString(e);
            }).join("");
          }(t) + "</svg>";

          n.innerHTML = "" + r, e.textContent = "", Array.prototype.slice.call(n.childNodes[0].childNodes).forEach(function (t) {
            e.appendChild(t);
          });
        }
      },
          g = function g(e, t, n, r) {
        if (n) {
          var a;

          try {
            a = new DOMParser().parseFromString(n, "text/xml");
          } catch (e) {
            a = void 0;
          }

          if (!a || a.getElementsByTagName("parsererror").length) return r("Unable to parse SVG file: " + a.getElementsByTagName("parsererror")[0].innerHTML), !1;
          h(e, a.documentElement), r();
        } else {
          var o = e.getAttribute("data-src") || e.getAttribute("src");
          if (e.setAttribute("src", ""), -1 !== f.indexOf(e)) return;
          f.push(e), m(o, function (t) {
            h(e, t), r();
          });
        }
      },
          b = function b(e, t, n) {
        (t = t || {}).pngFallback;
        var r = t.each,
            a = t.svgXML;

        if (void 0 !== e.length) {
          var o = 0;
          u.call(e, function (t) {
            g(t, 0, a, function () {
              r && "function" == typeof r && r(), n && e.length === ++o && n(o);
            });
          });
        } else e ? g(e, 0, a, function () {
          r && "function" == typeof r && r(), n && n(1), e = null;
        }) : n && n(0);
      };

      "object" === a(e) && "object" === a(e.exports) ? e.exports = t = b : void 0 === (r = function () {
        return b;
      }.call(t, n, t, e)) || (e.exports = r);
    }(window, document);
  }).call(this, n(15)(e));
}, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      a = i(n(0)),
      o = i(n(1)),
      l = i(n(9));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var u = /(\w+)_(\S+)/,
      s = {
    xlink: "http://www.w3.org/1999/xlink"
  },
      c = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.elemRefs = [], n.svgRef = null, n.path = null, n.originalValues = {}, n.onSvgUpdated = n.onSvgUpdated.bind(n), n.updateSvgElements = n.updateSvgElements.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), r(t, [{
      key: "componentDidMount",
      value: function value() {
        this.updateSvgElements(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.selector !== e.selector && (this.elemRefs = []), this.updateSvgElements(this.props);
      }
    }, {
      key: "onSvgUpdated",
      value: function value() {
        this.updateSvgElements(this.props, !0);
      }
    }, {
      key: "updateSvgElements",
      value: function value(e, t) {
        var n = this.svgRef;

        if (n && (0 === this.elemRefs.length || t)) {
          var r = [].slice.apply(n.querySelectorAll(e.selector));
          0 === r.length && -1 !== ["svg", "root"].indexOf(e.selector) && r.push(n), e.onElementSelected && r.length && e.onElementSelected(1 === r.length ? r[0] : r), this.elemRefs = r;
        }

        if (this.elemRefs) for (var a = Object.keys(e), o = 0; o < a.length; o += 1) {
          var l = a[o];

          if (!(-1 !== ["selector", "onElementSelected"].indexOf(l))) {
            var i = null,
                c = null,
                f = null,
                p = u.exec(l);
            p && p[1] ? (i = p[1], c = s[i], f = i + ":" + p[2]) : f = l;

            for (var d = 0; d < this.elemRefs.length; d += 1) {
              var y = this.elemRefs[d];
              if ("function" == typeof e[l]) y[l.toLowerCase()] = e[l];else {
                if ("string" != typeof e[l]) return;
                null == this.originalValues[l] && (this.originalValues[l] = y.getAttributeNS(c, f) || "");
                var m = e[l].replace("$ORIGINAL", this.originalValues[l]);
                y.setAttributeNS(c, f, m), "string" == typeof e.children && e.children.trim().length && (y.textContent = e.children);
              }
            }
          }
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return a.default.createElement(l.default.Consumer, null, function (t) {
          var n = t.path,
              r = t.svg,
              a = t.svgCount;
          e.svgCount && e.svgCount !== a ? e.onSvgUpdated() : (e.svgRef = r, e.path = n, e.svgCount = a);
        });
      }
    }]), t;
  }(a.default.Component);

  t.default = c, c.propTypes = {
    selector: o.default.string.isRequired,
    onElementSelected: o.default.func
  }, c.defaultProps = {
    onElementSelected: function onElementSelected() {}
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TransformMotion = t.AttributeMotion = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = u(n(0)),
      o = u(n(1)),
      l = n(18),
      i = n(8);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function s(e) {
    return a.default.createElement(l.Motion, {
      defaultStyle: e.start,
      style: {
        x: (0, l.spring)(e.target.x || 0),
        y: (0, l.spring)(e.target.y || 0),
        angle: (0, l.spring)(e.target.angle || 0),
        rotateX: (0, l.spring)(e.target.rotateX || 0),
        rotateY: (0, l.spring)(e.target.rotateY || 0)
      }
    }, function (t) {
      var n = "$ORIGINAL translate(" + t.x + "," + t.y + ") rotate(" + t.angle + " " + t.rotateX + " " + t.rotateY + ")";
      return a.default.createElement(i.SvgProxy, {
        selector: e.selector,
        transform: n
      });
    });
  },
      c = {
    x: o.default.number,
    y: o.default.number,
    angle: o.default.number,
    rotateX: o.default.number,
    rotateY: o.default.number
  };

  s.propTypes = {
    start: o.default.shape(c),
    target: o.default.shape(c),
    selector: o.default.string.isRequired
  }, s.defaultProps = {
    start: {
      x: 0,
      y: 0,
      angle: 0,
      rotateX: 0,
      rotateY: 0
    },
    target: {
      x: 0,
      y: 0,
      angle: 0,
      rotateX: 0,
      rotateY: 0
    }
  };

  var f = function f(e) {
    var t = {};
    return Object.keys(e.target).forEach(function (n) {
      t[n] = (0, l.spring)(e.target[n]);
    }), a.default.createElement(l.Motion, {
      defaultStyle: e.start,
      style: t
    }, function (t) {
      var n = r({}, t);
      return Object.keys(n).forEach(function (t) {
        n[t] = e.formatValue(n[t]);
      }), a.default.createElement(i.SvgProxy, r({
        selector: e.selector
      }, n));
    });
  };

  f.propTypes = {
    selector: o.default.string.isRequired,
    start: o.default.object.isRequired,
    target: o.default.object.isRequired,
    formatValue: o.default.func
  }, f.defaultProps = {
    formatValue: function formatValue(e) {
      return e.toString();
    }
  }, t.AttributeMotion = f, t.TransformMotion = s;
}, function (e, t, n) {
  "use strict";

  function r(e) {
    return e && e.__esModule ? e.default : e;
  }

  t.__esModule = !0;
  var a = n(19);
  t.Motion = r(a);
  var o = n(22);
  t.StaggeredMotion = r(o);
  var l = n(23);
  t.TransitionMotion = r(l);
  var i = n(25);
  t.spring = r(i);
  var u = n(11);
  t.presets = r(u);
  var s = n(2);
  t.stripStyle = r(s);
  var c = n(26);
  t.reorderKeys = r(c);
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = o(n(3)),
      i = o(n(2)),
      u = o(n(4)),
      s = o(n(5)),
      c = o(n(6)),
      f = o(n(7)),
      p = o(n(0)),
      d = o(n(1)),
      y = function (e) {
    function t(n) {
      var a = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
        var t = !1,
            n = a.state,
            o = n.currentStyle,
            l = n.currentVelocity,
            i = n.lastIdealStyle,
            u = n.lastIdealVelocity;

        for (var s in e) {
          if (Object.prototype.hasOwnProperty.call(e, s)) {
            var c = e[s];
            "number" == typeof c && (t || (t = !0, o = r({}, o), l = r({}, l), i = r({}, i), u = r({}, u)), o[s] = c, l[s] = 0, i[s] = c, u[s] = 0);
          }
        }

        t && a.setState({
          currentStyle: o,
          currentVelocity: l,
          lastIdealStyle: i,
          lastIdealVelocity: u
        });
      }, this.startAnimationIfNecessary = function () {
        a.animationID = c.default(function (e) {
          var t = a.props.style;
          if (f.default(a.state.currentStyle, t, a.state.currentVelocity)) return a.wasAnimating && a.props.onRest && a.props.onRest(), a.animationID = null, a.wasAnimating = !1, void (a.accumulatedTime = 0);
          a.wasAnimating = !0;
          var n = e || s.default(),
              r = n - a.prevTime;
          if (a.prevTime = n, a.accumulatedTime = a.accumulatedTime + r, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();
          var o = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60),
              l = Math.floor(a.accumulatedTime / (1e3 / 60)),
              i = {},
              c = {},
              p = {},
              d = {};

          for (var y in t) {
            if (Object.prototype.hasOwnProperty.call(t, y)) {
              var m = t[y];
              if ("number" == typeof m) p[y] = m, d[y] = 0, i[y] = m, c[y] = 0;else {
                for (var h = a.state.lastIdealStyle[y], v = a.state.lastIdealVelocity[y], g = 0; g < l; g++) {
                  var b = u.default(1e3 / 60 / 1e3, h, v, m.val, m.stiffness, m.damping, m.precision);
                  h = b[0], v = b[1];
                }

                var S = u.default(1e3 / 60 / 1e3, h, v, m.val, m.stiffness, m.damping, m.precision),
                    w = S[0],
                    O = S[1];
                p[y] = h + (w - h) * o, d[y] = v + (O - v) * o, i[y] = h, c[y] = v;
              }
            }
          }

          a.animationID = null, a.accumulatedTime -= l * (1e3 / 60), a.setState({
            currentStyle: p,
            currentVelocity: d,
            lastIdealStyle: i,
            lastIdealVelocity: c
          }), a.unreadPropStyle = null, a.startAnimationIfNecessary();
        });
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), a(t, null, [{
      key: "propTypes",
      value: {
        defaultStyle: d.default.objectOf(d.default.number),
        style: d.default.objectOf(d.default.oneOfType([d.default.number, d.default.object])).isRequired,
        children: d.default.func.isRequired,
        onRest: d.default.func
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyle,
          n = e.style,
          r = t || i.default(n),
          a = l.default(r);
      return {
        currentStyle: r,
        currentVelocity: a,
        lastIdealStyle: r,
        lastIdealVelocity: a
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = s.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = s.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      null != this.animationID && (c.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = this.props.children(this.state.currentStyle);
      return e && p.default.Children.only(e);
    }, t;
  }(p.default.Component);

  t.default = y, e.exports = t.default;
}, function (e, t) {
  var n;

  n = function () {
    return this;
  }();

  try {
    n = n || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (n = window);
  }

  e.exports = n;
}, function (e, t, n) {
  (function (t) {
    (function () {
      var n, r, a, o, l, i;
      "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
        return performance.now();
      } : null != t && t.hrtime ? (e.exports = function () {
        return (n() - l) / 1e6;
      }, r = t.hrtime, o = (n = function n() {
        var e;
        return 1e9 * (e = r())[0] + e[1];
      })(), i = 1e9 * t.uptime(), l = o - i) : Date.now ? (e.exports = function () {
        return Date.now() - a;
      }, a = Date.now()) : (e.exports = function () {
        return new Date().getTime() - a;
      }, a = new Date().getTime());
    }).call(this);
  }).call(this, n(10));
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = o(n(3)),
      i = o(n(2)),
      u = o(n(4)),
      s = o(n(5)),
      c = o(n(6)),
      f = o(n(7)),
      p = o(n(0)),
      d = o(n(1));

  var y = function (e) {
    function t(n) {
      var a = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
        for (var t = a.state, n = t.currentStyles, o = t.currentVelocities, l = t.lastIdealStyles, i = t.lastIdealVelocities, u = !1, s = 0; s < e.length; s++) {
          var c = e[s],
              f = !1;

          for (var p in c) {
            if (Object.prototype.hasOwnProperty.call(c, p)) {
              var d = c[p];
              "number" == typeof d && (f || (f = !0, u = !0, n[s] = r({}, n[s]), o[s] = r({}, o[s]), l[s] = r({}, l[s]), i[s] = r({}, i[s])), n[s][p] = d, o[s][p] = 0, l[s][p] = d, i[s][p] = 0);
            }
          }
        }

        u && a.setState({
          currentStyles: n,
          currentVelocities: o,
          lastIdealStyles: l,
          lastIdealVelocities: i
        });
      }, this.startAnimationIfNecessary = function () {
        a.animationID = c.default(function (e) {
          var t = a.props.styles(a.state.lastIdealStyles);
          if (function (e, t, n) {
            for (var r = 0; r < e.length; r++) {
              if (!f.default(e[r], t[r], n[r])) return !1;
            }

            return !0;
          }(a.state.currentStyles, t, a.state.currentVelocities)) return a.animationID = null, void (a.accumulatedTime = 0);
          var n = e || s.default(),
              r = n - a.prevTime;
          if (a.prevTime = n, a.accumulatedTime = a.accumulatedTime + r, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();

          for (var o = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), l = Math.floor(a.accumulatedTime / (1e3 / 60)), i = [], c = [], p = [], d = [], y = 0; y < t.length; y++) {
            var m = t[y],
                h = {},
                v = {},
                g = {},
                b = {};

            for (var S in m) {
              if (Object.prototype.hasOwnProperty.call(m, S)) {
                var w = m[S];
                if ("number" == typeof w) h[S] = w, v[S] = 0, g[S] = w, b[S] = 0;else {
                  for (var O = a.state.lastIdealStyles[y][S], T = a.state.lastIdealVelocities[y][S], P = 0; P < l; P++) {
                    var _ = u.default(1e3 / 60 / 1e3, O, T, w.val, w.stiffness, w.damping, w.precision);

                    O = _[0], T = _[1];
                  }

                  var j = u.default(1e3 / 60 / 1e3, O, T, w.val, w.stiffness, w.damping, w.precision),
                      k = j[0],
                      M = j[1];
                  h[S] = O + (k - O) * o, v[S] = T + (M - T) * o, g[S] = O, b[S] = T;
                }
              }
            }

            p[y] = h, d[y] = v, i[y] = g, c[y] = b;
          }

          a.animationID = null, a.accumulatedTime -= l * (1e3 / 60), a.setState({
            currentStyles: p,
            currentVelocities: d,
            lastIdealStyles: i,
            lastIdealVelocities: c
          }), a.unreadPropStyles = null, a.startAnimationIfNecessary();
        });
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), a(t, null, [{
      key: "propTypes",
      value: {
        defaultStyles: d.default.arrayOf(d.default.objectOf(d.default.number)),
        styles: d.default.func.isRequired,
        children: d.default.func.isRequired
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyles,
          n = e.styles,
          r = t || n().map(i.default),
          a = r.map(function (e) {
        return l.default(e);
      });
      return {
        currentStyles: r,
        currentVelocities: a,
        lastIdealStyles: r,
        lastIdealVelocities: a
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = s.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = s.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      null != this.animationID && (c.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = this.props.children(this.state.currentStyles);
      return e && p.default.Children.only(e);
    }, t;
  }(p.default.Component);

  t.default = y, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = o(n(3)),
      i = o(n(2)),
      u = o(n(4)),
      s = o(n(24)),
      c = o(n(5)),
      f = o(n(6)),
      p = o(n(7)),
      d = o(n(0)),
      y = o(n(1));

  function m(e, t, n) {
    var r = t;
    return null == r ? e.map(function (e, t) {
      return {
        key: e.key,
        data: e.data,
        style: n[t]
      };
    }) : e.map(function (e, t) {
      for (var a = 0; a < r.length; a++) {
        if (r[a].key === e.key) return {
          key: r[a].key,
          data: r[a].data,
          style: n[t]
        };
      }

      return {
        key: e.key,
        data: e.data,
        style: n[t]
      };
    });
  }

  function h(e, t, n, r, a, o, i, u, c) {
    for (var f = s.default(r, a, function (e, r) {
      var a = t(r);
      return null == a ? (n({
        key: r.key,
        data: r.data
      }), null) : p.default(o[e], a, i[e]) ? (n({
        key: r.key,
        data: r.data
      }), null) : {
        key: r.key,
        data: r.data,
        style: a
      };
    }), d = [], y = [], m = [], h = [], v = 0; v < f.length; v++) {
      for (var g = f[v], b = null, S = 0; S < r.length; S++) {
        if (r[S].key === g.key) {
          b = S;
          break;
        }
      }

      if (null == b) {
        var w = e(g);
        d[v] = w, m[v] = w;
        var O = l.default(g.style);
        y[v] = O, h[v] = O;
      } else d[v] = o[b], m[v] = u[b], y[v] = i[b], h[v] = c[b];
    }

    return [f, d, y, m, h];
  }

  var v = function (e) {
    function t(n) {
      var a = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
        for (var t = h(a.props.willEnter, a.props.willLeave, a.props.didLeave, a.state.mergedPropsStyles, e, a.state.currentStyles, a.state.currentVelocities, a.state.lastIdealStyles, a.state.lastIdealVelocities), n = t[0], o = t[1], l = t[2], i = t[3], u = t[4], s = 0; s < e.length; s++) {
          var c = e[s].style,
              f = !1;

          for (var p in c) {
            if (Object.prototype.hasOwnProperty.call(c, p)) {
              var d = c[p];
              "number" == typeof d && (f || (f = !0, o[s] = r({}, o[s]), l[s] = r({}, l[s]), i[s] = r({}, i[s]), u[s] = r({}, u[s]), n[s] = {
                key: n[s].key,
                data: n[s].data,
                style: r({}, n[s].style)
              }), o[s][p] = d, l[s][p] = 0, i[s][p] = d, u[s][p] = 0, n[s].style[p] = d);
            }
          }
        }

        a.setState({
          currentStyles: o,
          currentVelocities: l,
          mergedPropsStyles: n,
          lastIdealStyles: i,
          lastIdealVelocities: u
        });
      }, this.startAnimationIfNecessary = function () {
        a.unmounting || (a.animationID = f.default(function (e) {
          if (!a.unmounting) {
            var t = a.props.styles,
                n = "function" == typeof t ? t(m(a.state.mergedPropsStyles, a.unreadPropStyles, a.state.lastIdealStyles)) : t;
            if (function (e, t, n, r) {
              if (r.length !== t.length) return !1;

              for (var a = 0; a < r.length; a++) {
                if (r[a].key !== t[a].key) return !1;
              }

              for (a = 0; a < r.length; a++) {
                if (!p.default(e[a], t[a].style, n[a])) return !1;
              }

              return !0;
            }(a.state.currentStyles, n, a.state.currentVelocities, a.state.mergedPropsStyles)) return a.animationID = null, void (a.accumulatedTime = 0);
            var r = e || c.default(),
                o = r - a.prevTime;
            if (a.prevTime = r, a.accumulatedTime = a.accumulatedTime + o, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();

            for (var l = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), i = Math.floor(a.accumulatedTime / (1e3 / 60)), s = h(a.props.willEnter, a.props.willLeave, a.props.didLeave, a.state.mergedPropsStyles, n, a.state.currentStyles, a.state.currentVelocities, a.state.lastIdealStyles, a.state.lastIdealVelocities), f = s[0], d = s[1], y = s[2], v = s[3], g = s[4], b = 0; b < f.length; b++) {
              var S = f[b].style,
                  w = {},
                  O = {},
                  T = {},
                  P = {};

              for (var _ in S) {
                if (Object.prototype.hasOwnProperty.call(S, _)) {
                  var j = S[_];
                  if ("number" == typeof j) w[_] = j, O[_] = 0, T[_] = j, P[_] = 0;else {
                    for (var k = v[b][_], M = g[b][_], I = 0; I < i; I++) {
                      var x = u.default(1e3 / 60 / 1e3, k, M, j.val, j.stiffness, j.damping, j.precision);
                      k = x[0], M = x[1];
                    }

                    var E = u.default(1e3 / 60 / 1e3, k, M, j.val, j.stiffness, j.damping, j.precision),
                        A = E[0],
                        V = E[1];
                    w[_] = k + (A - k) * l, O[_] = M + (V - M) * l, T[_] = k, P[_] = M;
                  }
                }
              }

              v[b] = T, g[b] = P, d[b] = w, y[b] = O;
            }

            a.animationID = null, a.accumulatedTime -= i * (1e3 / 60), a.setState({
              currentStyles: d,
              currentVelocities: y,
              lastIdealStyles: v,
              lastIdealVelocities: g,
              mergedPropsStyles: f
            }), a.unreadPropStyles = null, a.startAnimationIfNecessary();
          }
        }));
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), a(t, null, [{
      key: "propTypes",
      value: {
        defaultStyles: y.default.arrayOf(y.default.shape({
          key: y.default.string.isRequired,
          data: y.default.any,
          style: y.default.objectOf(y.default.number).isRequired
        })),
        styles: y.default.oneOfType([y.default.func, y.default.arrayOf(y.default.shape({
          key: y.default.string.isRequired,
          data: y.default.any,
          style: y.default.objectOf(y.default.oneOfType([y.default.number, y.default.object])).isRequired
        }))]).isRequired,
        children: y.default.func.isRequired,
        willEnter: y.default.func,
        willLeave: y.default.func,
        didLeave: y.default.func
      },
      enumerable: !0
    }, {
      key: "defaultProps",
      value: {
        willEnter: function willEnter(e) {
          return i.default(e.style);
        },
        willLeave: function willLeave() {
          return null;
        },
        didLeave: function didLeave() {}
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyles,
          n = e.styles,
          r = e.willEnter,
          a = e.willLeave,
          o = e.didLeave,
          u = "function" == typeof n ? n(t) : n,
          s = void 0;
      s = null == t ? u : t.map(function (e) {
        for (var t = 0; t < u.length; t++) {
          if (u[t].key === e.key) return u[t];
        }

        return e;
      });
      var c = null == t ? u.map(function (e) {
        return i.default(e.style);
      }) : t.map(function (e) {
        return i.default(e.style);
      }),
          f = null == t ? u.map(function (e) {
        return l.default(e.style);
      }) : t.map(function (e) {
        return l.default(e.style);
      }),
          p = h(r, a, o, s, u, c, f, c, f),
          d = p[0];
      return {
        currentStyles: p[1],
        currentVelocities: p[2],
        lastIdealStyles: p[3],
        lastIdealVelocities: p[4],
        mergedPropsStyles: d
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = c.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
      var t = e.styles;
      this.unreadPropStyles = "function" == typeof t ? t(m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : t, null == this.animationID && (this.prevTime = c.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      this.unmounting = !0, null != this.animationID && (f.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
          t = this.props.children(e);
      return t && d.default.Children.only(t);
    }, t;
  }(d.default.Component);

  t.default = v, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function (e, t, n) {
    for (var r = {}, a = 0; a < e.length; a++) {
      r[e[a].key] = a;
    }

    var o = {};

    for (a = 0; a < t.length; a++) {
      o[t[a].key] = a;
    }

    var l = [];

    for (a = 0; a < t.length; a++) {
      l[a] = t[a];
    }

    for (a = 0; a < e.length; a++) {
      if (!Object.prototype.hasOwnProperty.call(o, e[a].key)) {
        var i = n(a, e[a]);
        null != i && l.push(i);
      }
    }

    return l.sort(function (e, n) {
      var a = o[e.key],
          l = o[n.key],
          i = r[e.key],
          u = r[n.key];
      if (null != a && null != l) return o[e.key] - o[n.key];
      if (null != i && null != u) return r[e.key] - r[n.key];

      if (null != a) {
        for (var s = 0; s < t.length; s++) {
          var c = t[s].key;

          if (Object.prototype.hasOwnProperty.call(r, c)) {
            if (a < o[c] && u > r[c]) return -1;
            if (a > o[c] && u < r[c]) return 1;
          }
        }

        return 1;
      }

      for (s = 0; s < t.length; s++) {
        c = t[s].key;

        if (Object.prototype.hasOwnProperty.call(r, c)) {
          if (l < o[c] && i > r[c]) return 1;
          if (l > o[c] && i < r[c]) return -1;
        }
      }

      return -1;
    });
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  };

  t.default = function (e, t) {
    return r({}, i, t, {
      val: e
    });
  };

  var a,
      o = n(11),
      l = (a = o) && a.__esModule ? a : {
    default: a
  },
      i = r({}, l.default.noWobble, {
    precision: .01
  });
  e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.default = function () {
    0;
  };
  e.exports = t.default;
}]);